import { useSearchParams } from "react-router-dom";
import { useRouteParams } from "src/hooks/useRouteParams";
import { ProductOfferingConfigsPageView } from "src/routes/libraries/product-offering-configs/ProductOfferingConfigsPage";
import { ProjectParams } from "src/routes/routesDef";

export function ProjectProductOfferingConfigsPage() {
  const { projectId, productOfferingId } = useRouteParams<ProjectParams & { productOfferingId: string }>();
  const [searchParams] = useSearchParams();
  const rpavId = searchParams.get("rpavId") ?? undefined;
  return <ProductOfferingConfigsPageView marketsOrIds={{ projectId, productOfferingId, rpavId }} />;
}
